import { createFileRoute } from '@tanstack/react-router';
import {
  AnalyticsPipelinePage,
  analyticsDevicesHealthQueryOptions,
  analyticsLoaderDeps,
  analyticsPipelineQueryOptions,
} from '@/features/analytics';
import { useAuthStore } from '@/stores/auth';

export const Route = createFileRoute('/_authed/analytics/pipeline')({
  loaderDeps: ({ search }) => analyticsLoaderDeps(search),
  loader: ({ context, deps }) => {
    const activeBranchId = useAuthStore.getState().activeBranchId;
    const branchId = activeBranchId && activeBranchId !== 'all' ? activeBranchId : undefined;

    void Promise.all([
      context.queryClient.prefetchQuery(
        analyticsPipelineQueryOptions({
          period: deps.period,
          branch_id: branchId,
        }),
      ),
      context.queryClient.prefetchQuery(
        analyticsDevicesHealthQueryOptions({
          branch_id: branchId,
        }),
      ),
    ]);
  },
  component: AnalyticsPipelinePage,
});
